import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Zap, Ticket, Sparkles, Trophy } from 'lucide-react';
export function Slide03Solution() {
  const features = [{
    icon: <Ticket className="w-6 h-6 text-accent" data-id="element-119" />,
    title: 'Digital Drawings',
    desc: 'Players earn entries into recurring prize drawings.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-accent-secondary" data-id="element-120" />,
    title: 'Instant Win',
    desc: 'Reveal a prize on the spot — win right at the pump.'
  }, {
    icon: <Trophy className="w-6 h-6 text-accent" data-id="element-121" />,
    title: 'Sports Prediction Contests',
    desc: 'Pick the winners and compete for the top prize.'
  }];
  return <div className="w-full min-h-full flex flex-col justify-center p-[clamp(1.5rem,6vw,6rem)]" data-id="element-122">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-[clamp(1.25rem,3vw,2.5rem)]" data-id="element-123">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/10 border border-accent/30 text-accent text-xs md:text-sm font-bold tracking-wide uppercase mb-3 md:mb-5" data-id="element-124">
          <Gift size={16} data-id="element-125" />
          100% Free to Play
        </div>
        <h2 className="text-[clamp(2rem,4vw,4rem)] font-bold leading-tight" data-id="element-126">
          The Solution: <span className="text-accent" data-id="element-127">Play While You Pump</span>
        </h2>
      </motion.div>

      <div className="flex flex-col lg:grid lg:grid-cols-12 gap-[clamp(1.5rem,4vw,4rem)] items-center flex-1 min-h-0" data-id="element-128">
        {/* Left: Features */}
        <div className="lg:col-span-5 flex flex-col justify-center gap-[clamp(0.75rem,1.5vw,1.25rem)] w-full" data-id="element-129">
          {features.map((f, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2 + i * 0.15
        }} className="p-[clamp(1rem,2vw,1.5rem)] rounded-2xl bg-surface border border-surface-hover hover:border-accent/30 transition-colors group flex flex-row lg:flex-col items-center lg:items-start gap-4 lg:gap-0" data-id="element-130">
              <div className="w-11 h-11 shrink-0 rounded-xl bg-background flex items-center justify-center lg:mb-3 group-hover:scale-110 transition-transform" data-id="element-131">
                {f.icon}
              </div>
              <div data-id="element-132">
                <h3 className="text-base md:text-lg font-bold mb-0.5 md:mb-1" data-id="element-133">
                  {f.title}
                </h3>
                <p className="text-xs md:text-sm text-muted leading-relaxed" data-id="element-134">
                  {f.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Right: Phone Mockup Visual */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 0.7
      }} className="hidden lg:flex lg:col-span-7 relative items-center justify-center w-full" data-id="element-135">
          <div className="absolute inset-0 bg-gradient-to-tr from-accent/10 to-transparent rounded-3xl" data-id="element-136" />

          {/* Abstract Phone */}
          <div className="relative h-[min(64vh,600px)] max-w-full aspect-[9/19] bg-background rounded-[3rem] border-[8px] border-surface shadow-2xl overflow-hidden flex flex-col" data-id="element-137">
            {/* Notch */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-surface rounded-b-2xl z-20" data-id="element-138" />

            {/* Game Screen UI */}
            <div className="flex-1 bg-surface-hover p-6 flex flex-col relative overflow-hidden" data-id="element-139">
              <div className="absolute top-[-20%] right-[-20%] w-64 h-64 bg-accent/20 rounded-full blur-3xl" data-id="element-140" />

              <div className="mt-8 text-center relative z-10" data-id="element-141">
                <div className="text-accent font-black text-4xl tracking-tighter mb-1" data-id="element-142">
                  SPIN
                </div>
                <div className="text-white font-bold text-xl" data-id="element-143">& WIN</div>
              </div>

              <div className="flex-1 flex items-center justify-center relative z-10" data-id="element-144">
                {/* Abstract Slot/Wheel */}
                <div className="w-48 h-48 rounded-full border-4 border-surface bg-background flex items-center justify-center relative shadow-[0_0_40px_rgba(59,246,93,0.3)]" data-id="element-145">
                  <div className="absolute inset-2 rounded-full border-2 border-dashed border-accent/50 animate-[spin_10s_linear_infinite]" data-id="element-146" />
                  <Zap className="w-16 h-16 text-accent-secondary" data-id="element-147" />
                </div>
              </div>

              <div className="mt-auto relative z-10" data-id="element-148">
                <div className="w-full py-4 rounded-xl bg-accent text-accent-contrast font-bold text-center text-lg shadow-[0_0_20px_rgba(59,246,93,0.4)]" data-id="element-149">
                  TAP TO PLAY
                </div>
              </div>
            </div>
          </div>

          {/* Floating Elements */}
          <motion.div animate={{
          y: [-10, 10, -10]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute top-1/4 -right-8 lg:right-12 px-6 py-4 rounded-2xl bg-surface border border-surface-hover shadow-xl flex items-center gap-3" data-id="element-150">
            <div className="w-10 h-10 rounded-full bg-accent/20 flex items-center justify-center" data-id="element-151">
              <Gift className="w-5 h-5 text-accent" data-id="element-152" />
            </div>
            <div data-id="element-153">
              <div className="text-sm font-bold text-white" data-id="element-154">Winner!</div>
              <div className="text-xs text-muted" data-id="element-155">$10 Freeplay</div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>;
}